import React from 'react';
import PropTypes from 'prop-types';

const UiNavigationBackPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M12.618 16.036l8.542 8.506a.298.298 0 0 1 0 .422l-.95.949a.298.298 0 0 1-.42 0l-9.703-9.702a.298.298 0 0 1 0-.422l9.702-9.702a.298.298 0 0 1 .422 0l.949.986a.298.298 0 0 1 0 .421l-8.542 8.542z"
    />
  );
};

UiNavigationBackPath.propTypes = {
  fill: PropTypes.string,
};

export default UiNavigationBackPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/ui-controls/ui-navigation-back.jsx